import { post } from './request'

export function buildingAdd(data) {
  return post('/api/Building/Add', data)
}

export function buildingUpdate(data) {
  return post('/api/Building/Update', data)
}

export function buildingList(data) {
  return post('/api/Building/List', data)
}

export function buildingDetail(data) {
  return post('/api/Building/Detail', data)
}

export function buildingDelete(data) {
  return post('/api/Building/Delete', data)
}
